(function () {
  'use strict';

  angular.module('app').component('paymentMethodDetail', paymentMethodDetail());

  function paymentMethodDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onPaymentMethodSaved: '&',
        onPaymentMethodCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: PaymentMethodDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/payment-methods/payment-method-detail/payment-method-detail.component.html',
    };
  }

  PaymentMethodDetailComponent.$inject = ['UtilService', 'PaymentMethodService'];

  function PaymentMethodDetailComponent(UtilService, PaymentMethodService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var fieldsDefinition = ['name', 'incoming', 'outgoing', 'requires_reference_number'];

    // Methods
    vm.editPaymentMethod = editPaymentMethod;
    vm.cancelEdit = cancelEdit;
    vm.openTranslations = openTranslations;
    vm.savePaymentMethod = savePaymentMethod;
    vm.cancel = cancel;
    vm.formIsInvalid = formIsInvalid;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          code: '99', // = Other
          incoming: true,
          outgoing: true,
          requires_reference_number: false,
        };
      }
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        editPaymentMethod();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    function editPaymentMethod() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function openTranslations() {
      PaymentMethodService.openPaymentMethodTranslations(vm.item, vm.additionalLanguages);
    }

    // Create/Update
    function savePaymentMethod(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (!vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        return cancel();
      }

      vm.sendingForm = true;
      PaymentMethodService.savePaymentMethod(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // setItemOptions(response);
          vm.onPaymentMethodSaved({ item: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      /*if (vm.editMode) {
                vm.cancelEdit();
                return;
            }*/

      vm.onPaymentMethodCanceled({ item: vm.item });
    }

    function formIsInvalid() {
      if (!vm.item.incoming && !vm.item.outgoing) {
        return true;
      }

      return false;
    }
  }
})();
